import createPlugin from './createPlugin'
import ProductComparisonRenderer from './Renderer'

const ProductComparisonPlugin = (settings) =>
    createPlugin({
        Renderer: ProductComparisonRenderer,
        ...settings,
    })

const ProductComparison = ProductComparisonPlugin()
export default ProductComparison

export { ProductComparisonPlugin, ProductComparisonRenderer }
